import React from "react";
import logoMobile from "../../../assets/logoa2.png";
import { useEffect } from "react";
import { FaRegStickyNote, FaRegEnvelope } from "react-icons/fa";
import { SiDatabricks } from "react-icons/si";
import { AiOutlineUser,AiOutlineInfoCircle} from "react-icons/ai";
import { BiExit} from "react-icons/bi";
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';
import { Link } from "react-router-dom";
const Menu = () => {

  const {toggel,setToggel} = useContext(userContext)


  useEffect(() => {
    if (window.innerWidth >= 992) {
      setToggel(true);
    } else {
      setToggel(false);
    }
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setToggel(true);
      } else {
        setToggel(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleResize);
    };
  }, []);

  const clicItem = () => {
    if (window.innerWidth <= 992) {
      setToggel(false);
    }
  }

  return (
    <div className="" style={{height:"85vh"}}>
      <div className={`userpanel-menu ${toggel ? "show-menu" : ""}`}>
        <img alt="" src={logoMobile} className="user-menu-logo" />
        <div className="mt-4">
        <ul className="userpanel-menu-list" >
        <Link onClick={()=> clicItem()} className="userpanel-menu-list-item" to="/user/request"><li className="mb-5"><FaRegStickyNote/>&nbsp;&nbsp; درخواست نوبت کارشناسی</li></Link>
        <Link onClick={()=> clicItem()} className="userpanel-menu-list-item" to="/user/requests"><li className="mb-5"> <SiDatabricks/> &nbsp;&nbsp; سوابق درخواست ها</li></Link>
        <Link onClick={()=> clicItem()} className="userpanel-menu-list-item" to="/user/messages"><li className="mb-5"> <FaRegEnvelope/> &nbsp;&nbsp;صندوق پیام</li></Link>
        <Link onClick={()=> clicItem()} className="userpanel-menu-list-item" to="/user/support"> <li className="mb-5"> <AiOutlineUser/> &nbsp;&nbsp;پشتیبانی</li></Link>
        <Link onClick={()=> clicItem()} className="userpanel-menu-list-item" to="/user/real-estate"><li className="mb-5"> <AiOutlineInfoCircle/> &nbsp;&nbsp;ارسال برای املاک</li></Link>
        <Link  className="userpanel-menu-list-item" to="/" onClick={()=>{localStorage.removeItem("token")}}><li className="mb-5"> <BiExit/> &nbsp;&nbsp;خروج</li></Link>
      </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
